import React, { useState, useEffect, useContext } from "react";

import { useNavigate } from "react-router-dom";
import { colors } from "../../themes/Colors";
import { ManagerDisplay, Menu, TabNavigator } from "./components";
import {
  LoadingPopUp,
  ProfileHeader,
  ProfilePopUpDisplay,
  VehicleDisplayCrossModule,
} from "../common-components";
import { AuthContext } from "../../context/auth-context";
import useWindowDimensions from "../../dynamic-sizing-functions/get-diemensions/UseWindowDiemensions";
import SearchBar from "../common-components/search-bar/SearchBar";
import AddVehiclePopUp from "../common-components/vehicle-display-cross-module/components/add-vehicle-pop-up/AddVehiclePopUp";

const Organisation = () => {
  const { width, height } = useWindowDimensions();
  const auth = useContext(AuthContext);
  const [profileDisplay, setProfileDisplay] = useState(false);
  const [currentDisplay, setCurrentDisplay] = useState("profile");
  const [loading, setLoading] = useState(false);
  const [branchDisplay, setBranchDisplay] = useState("profile");
  const [addVehiclePopUp, setAddVehiclePopUp] = useState(false);
  return (
    <div
      style={{
        width: width,
        height: height,
        backgroundColor: colors.secondaryGrey,
        display: "flex",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {width >= 900 ? (
        <Menu
          onNoticeClick={() => setCurrentDisplay("notice")}
          onBuzzClick={() => setCurrentDisplay("buzz")}
          onProfileClick={() => setCurrentDisplay("profile")}
          onVehicleClick={() => setCurrentDisplay("vehicle")}
          selected={currentDisplay}
        />
      ) : null}
      {width >= 900 ? (
        <div
          style={{
            flex: 1,

            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <ProfileHeader
            isCustomer={true}
            backgroundColor={colors.orangeDark}
            username={
              auth
                ? auth.customerUserData.firstName +
                  " " +
                  auth.customerUserData.lastName
                : "loading"
            }
            onProfileClick={() =>
              setProfileDisplay(profileDisplay ? false : true)
            }
          />
          {currentDisplay === "profile" ? (
            <ManagerDisplay isMainAdmin={true} width={width} />
          ) : null}
          {currentDisplay === "vehicle" ? (
            <VehicleDisplayCrossModule type={"org"} width={width} />
          ) : null}
        </div>
      ) : (
        <div
          style={{
            width: width,
            height: height,
            backgroundColor: colors.secondaryGrey,
            display: "flex",
            position: "relative",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              width: "100%",
              minHeight: 50,
              borderBottomRightRadius: 10,
              borderBottomLeftRadius: 10,
              backgroundColor: colors.orangeDark,
              color: colors.white,
              fontWeight: "bold",
              transition: "all 0.3s",
              WebkitBoxShadow: "-5px 5px 15px -1px #00000070",
              // borderStyle: "solid",
              zIndex: 200,
              position: "relative",
            }}
          >
            <div style={{ marginLeft: 10, marginRight: 6 }}>
              {currentDisplay.toLocaleUpperCase()}
            </div>
            {/* <div> - {subSelection.toLocaleUpperCase()}</div> */}
            <div
              style={{
                flex: 1,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              {branchDisplay !== "branches" ? null : (
                <SearchBar color={colors.white} marginTop={-15} />
              )}
              <div style={{ marginRight: 7 }} />
            </div>
          </div>
          <div style={{ flex: 1 }}>
            {currentDisplay === "vehicle" ? (
              <VehicleDisplayCrossModule
                type={"org"}
                width={width}
                setAddVehiclePopUp={setAddVehiclePopUp}
              />
            ) : null}
            {currentDisplay === "profile" ? (
              <ManagerDisplay
                isMainAdmin={true}
                width={width}
                branchDisplay={branchDisplay}
                setBranchDisplay={setBranchDisplay}
              />
            ) : null}
          </div>
          <TabNavigator
            selected={currentDisplay}
            onVehicleClick={() => setCurrentDisplay("vehicle")}
            onBuzzClick={() => setCurrentDisplay("buzz")}
            onProfileClick={() => setCurrentDisplay("profile")}
          />
        </div>
      )}
      {width > 899 ? null : (
        <AddVehiclePopUp
          display={addVehiclePopUp}
          onCloseClick={() => setAddVehiclePopUp(false)}
        />
      )}
      <LoadingPopUp display={loading} color={"orange"} />
    </div>
  );
};

export default Organisation;
